import React from 'react';

const Card = ({ children, className = '', bordered = true }) => {
  const borderClass = bordered ? 'border border-[#E0E0E0]' : '';
  
  return (
    <div className={`bg-white rounded-lg p-4 shadow-sm ${borderClass} ${className}`}>
      {children}
    </div>
  );
};

export default Card;

